import { ReactNode } from 'react';

import useUserChannel from './vm';

export interface UserChannelProps {
  children: ReactNode;
}

const UserChannel = ({ children }: UserChannelProps) => {
  useUserChannel();
  return <>{children}</>;
};

export default UserChannel;
